import axiosInstance from "../../environment/axiosInstances";

export const orderNumberServices = {
    orderNumber
}

function orderNumber(data: any) {
    return axiosInstance.post(`admin/phone-numbers/order-number`, data);
}